<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import {
  NumberFieldDecrement as RekaNumberFieldDecrement,
  type NumberFieldDecrementProps,
  useForwardProps,
} from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { Minus } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = defineProps<NumberFieldDecrementProps & { class?: HTMLAttributes['class'] }>()
const delegated = reactiveOmit(props, 'class')
const forwarded = useForwardProps(delegated)
</script>

<template>
  <RekaNumberFieldDecrement
    data-slot="decrement"
    v-bind="forwarded"
    :class="
      cn(
        'absolute top-1/2 -translate-y-1/2 left-0 p-3 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed',
        props.class,
      )
    "
  >
    <slot>
      <Minus class="size-4" />
    </slot>
  </RekaNumberFieldDecrement>
</template>
